<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DocumentLog v-model="logsModel" />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import DocumentLog from "@/components/share/document-log-component";
import documentLogService from "@/helpers/service/document-log-provider";

export default {
  page: {
    title: "Document Logs",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DocumentLog,
  },
  data() {
    return {
      title: "Document Logs",
      items: [
        {
          text: "Document",
          href: "/",
        },
        {
          text: "Logs",
          active: true,
        },
      ],
      submitted: false,
      form: {
        message: "",
      },
      username: "Steven Franklin",
      logsModel: {
        logs: [],
        logTopic: "",
        referenceId: "",
      },
    };
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    async getLogs() {
      let result = await documentLogService.getDocumentLogsAsync(
        "600aa8d18a09b39ef4b83be2",
        "InventoryCategory"
      );
      if (result.status === 200) {
        this.logsModel.logs = result.data;
        this.logsModel.logTopic = "InventoryCategory";
        this.logsModel.referenceId = "600aa8d18a09b39ef4b83be2";
        // console.log(result.data);
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      }
    },
  },
};
</script>

